import _extends from '@babel/runtime/helpers/extends';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { forwardRef, useMultiStyleConfig, omitThemingProps, chakra, StylesProvider } from '@chakra-ui/react';
import { cx } from '@chakra-ui/utils';
import React__default from 'react';
import { times } from 'lodash-es';
import { StepIndicatorDot } from './StepIndicatorDot.js';
import { StepIndicatorLine } from './StepIndicatorLine.js';
var _excluded = ["currentStep", "totalSteps"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}

/**
 * Step indicator
 *
 * Shows the current step and total amount of steps as a line with dots.
 */
var StepIndicator = forwardRef(function (props, ref) {
  var styles = useMultiStyleConfig('StepIndicator', props);
  var _omitThemingProps = omitThemingProps(props),
    currentStep = _omitThemingProps.currentStep,
    totalSteps = _omitThemingProps.totalSteps,
    rest = _objectWithoutProperties(_omitThemingProps, _excluded);
  var containerStyles = _objectSpread({
    display: 'flex',
    justifyContent: 'space-between'
  }, styles.container);
  return /*#__PURE__*/React__default.createElement(chakra.div, _extends({
    ref: ref
  }, rest, {
    className: cx('chakra-step-indicator', props.className),
    __css: containerStyles
  }), /*#__PURE__*/React__default.createElement(StylesProvider, {
    value: styles
  }, times(totalSteps, function (index) {
    return /*#__PURE__*/React__default.createElement(chakra.div, {
      key: index,
      __css: {
        position: 'relative',
        flex: totalSteps === index + 1 ? 0 : 1
      }
    }, /*#__PURE__*/React__default.createElement(StepIndicatorDot, {
      isCurrentStep: index + 1 <= currentStep
    }), /*#__PURE__*/React__default.createElement(StepIndicatorLine, {
      isCurrentStep: index + 1 <= currentStep,
      isLastCurrentStep: index + 1 === currentStep
    }));
  })));
});
export { StepIndicator };